import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map, switchMap, filter, catchError, withLatestFrom } from 'rxjs/operators';
import * as actions from '../actions';
import {EventsService} from '../../services/events.service';
import {EventsParams, Events} from '../../models/events';

import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';



@Injectable()
export class EventsEffects {
  private actions$ = inject(Actions);
  private eventsService = inject(EventsService);
  private store$ = inject(Store<fromStore.State>);

  constructor() {}

  getEventsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.EventsTypes.GET_EVENTS),
    map((action: actions.GetEventAction) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap( ([payload, currentUser]) => {
        // 創建新對象副本以避免修改只讀的 action payload (NgRx 9 immutability)
        const enrichedPayload = currentUser ? { ...payload, otp: currentUser.otp } : payload;
        return this.eventsService.getDevicesEvents(enrichedPayload).pipe(
          map((res: any) => {
            if (res.result) {
              return new actions.GetEventsSuccessAction(res.msg.body);
            } else {
              return new actions.GetEventFailAction(res);
            }
          }),
          // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
          catchError(error => of(new actions.GetEventFailAction(error)))
        );
    })
  ));
}
